import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { getStoredData } from "../../api/fetchData.jsx";
import TableComponent from "../../components/TableComponent/TableComponent.jsx";
import "./AllTablePage.css";

const AllTablePage = () => {
  const { model } = useParams();
  const location = useLocation(); // 👈 to read live query strings
  const [config, setConfig] = useState(null);
  const [data, setData] = useState([]);
  const [filteredApi, setFilteredApi] = useState("");
  const [loading, setLoading] = useState(true);

  // 🔹 Load table config
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const json = await getStoredData();
        const tableConfigs = json["1"]?.tableConfigs || {};
        setConfig(tableConfigs[model] || null);
      } catch {
        setConfig(null);
      }
    };
    fetchConfig();
  }, [model]);

useEffect(() => {
  if (!config) return;

  let api = config.api;
  const params = new URLSearchParams(location.search);

  const selectedProject = localStorage.getItem("selectedProject");
  const fromManagement = location.pathname.startsWith("/management");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const isAdmin = user?.role === "Admin" || user?.role === "Super Admin";

  // Detect if project already passed in URL
  const hasProjectFilter = params.has("project");

  // Apply project filter only for non-admin users
  if (!fromManagement && !isAdmin && selectedProject && !hasProjectFilter) {
    params.set("project", selectedProject);
  }

  const queryString = params.toString();

  if (queryString) {
    api += api.includes("?") ? `&${queryString}` : `?${queryString}`;
  }

  setFilteredApi(api);
}, [config, location.search, location.pathname]);

  // 🔹 Fetch table data
  useEffect(() => {
    if (!filteredApi) return;
    setLoading(true);
    axios
      .get(filteredApi)
      .then((res) =>
        setData(Array.isArray(res.data) ? res.data : res.data?.data || [])
      )
      .catch((err) => console.error("Fetch error:", err))
      .finally(() => setLoading(false));
  }, [filteredApi]);

  if (!config)
    return <div style={{ padding: 20 }}>Invalid module: {model}</div>;

  return (
    <div className="TablePageContainer">
      <TableComponent
        title={config.title}
        data={data}
        columns={config.columns}
        api={filteredApi} // 👈 always send final API
        model={model}
        config={config}
      />
    </div>
  );
};

export default AllTablePage;
